import React from 'react';
import { Controller } from 'react-hook-form';
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

const periods = ['AM', 'PM'];

export default function TimeComponent({ control, name, disabled }) {
  return (
    <div className="w-100">
      <Controller
        name={`${name}.time`}
        control={control}
        rules={{
          pattern: {
            value: /^([01]\d|2[0-3]):?([0-5]\d)?$/,
            message: 'Invalid time. 12 hour format only e.g. 06:36',
          },
        }}
        render={({ field, fieldState }) => (
          <>
            <InputMask
              mask="99:99"
              placeholder="HH:MM"
              className={`input-shadow me-3 ${fieldState.invalid ? 'p-invalid' : ''}`}
              value={field.value || ''}
              onChange={(e) => field.onChange(e.value)}
              disabled={disabled}
            />
            {fieldState.error?.message && (
              <InputErrorMessage className="text-danger d-block">{fieldState.error?.message}</InputErrorMessage>
            )}
          </>
        )}
      />

      <Controller
        name={`${name}.period`}
        control={control}
        defaultValue="AM"
        render={({ field, fieldState }) => (
          <>
            <Dropdown
              value={field.value}
              options={periods}
              onChange={(e) => field.onChange(e.value)}
              className={`input-shadow ${fieldState.invalid ? 'p-invalid' : ''}`}
              style={{ width: 80 }}
              disabled={disabled}
            />
          </>
        )}
      />
    </div>
  );
}
